import React, { useState } from 'react';
import axios from 'axios';
import { errorMessage, fileSizeLabel } from '../../utils/staffDocuments';

// An uploaded PDF: its name and size, and a button that opens it in a new tab
export default function PdfPanel({ doc }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  // The tab is opened before the request so a pop-up blocker treats it as part of the click
  const open = async () => {
    const tab = window.open('', '_blank');
    setBusy(true);
    setError(null);
    try {
      const res = await axios.get(`/api/staff-documents/${doc.id}/file`, { responseType: 'blob' });
      const url = URL.createObjectURL(res.data);
      if (tab) tab.location.href = url;
      else window.location.href = url;
    } catch (err) {
      tab?.close();
      setError(errorMessage(err, "Couldn't open the document. Try again."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bk-card coc-pdf">
      <p className="coc-pdf__name">{doc.file?.fileName}{doc.file?.fileSize != null ? ` (${fileSizeLabel(doc.file.fileSize)})` : ''}</p>
      <button type="button" className="bk-btn bk-btn--primary bk-btn--full" onClick={open} disabled={busy}>
        {busy ? 'Opening…' : 'Open the document'}
      </button>
      {error && <p className="bk-form-error" role="alert">{error}</p>}
    </div>
  );
}
